import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  name: 'modal.component',
  props: {
  id: String,
},
  emits: ['onOpen','onClose'],
  setup(__props, { emit }) {





function onInit(el: Element) {
  if (el != null) {
    el.addEventListener('hidden.bs.modal', (event) => emit('onClose', event))
    el.addEventListener('shown.bs.modal', (event) => emit('onOpen', event))
  }
  
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    id: __props.id,
    ref: onInit,
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "body")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "footer")
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})